import type { ComponentChildren } from 'preact'

export function DetailRow({ label, value }: { label: string; value: ComponentChildren }) {
  return (
    <div>
      <div className="text-xs uppercase tracking-wide text-slate-500 dark:text-slate-400 mb-1">{label}</div>
      <div className="text-slate-900 dark:text-slate-200 break-words">{value}</div>
    </div>
  )
}
